import { getFaqs, saveFaq, deleteFaq } from '../../../lib/cms'

export default function AdminFaqs() {
  const [faqs, setFaqs] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [editItem, setEditItem] = useState<any | null>(null)
  const [saving, setSaving] = useState(false)
  const [deleteId, setDeleteId] = useState<number | null>(null)
  const [msg, setMsg] = useState('')

  const load = async () => {
    setLoading(true)
    setFaqs(await getFaqs())
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  const flash = (m: string) => { setMsg(m); setTimeout(() => setMsg(''), 3000) }

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!editItem) return
    setSaving(true)
    await saveFaq(editItem)
    await load()
    setEditItem(null)
    flash('FAQ sačuvan!')
    setSaving(false)
  }

  const handleDelete = async () => {
    if (!deleteId) return
    await deleteFaq(deleteId)
    await load()
    setDeleteId(null)
    flash('FAQ obrisan.')
  }

  return (
    <div className="space-y-4">
      {msg && <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg px-4 py-2 text-sm">{msg}</div>}

      <div className="flex items-center justify-between">
        <p className="text-gray-500 text-sm">{faqs.length} pitanja</p>
        <button
          onClick={() => setEditItem({ question: '', answer: '', sort_order: faqs.length })}
          className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg flex items-center gap-2 transition"
        >
          <i className="ri-add-line" /> Dodaj pitanje
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-400"><i className="ri-loader-4-line animate-spin text-2xl" /></div>
      ) : (
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={faq.id ?? idx} className="bg-white rounded-xl border border-gray-200 p-4">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900 text-sm">{faq.question}</p>
                  <p className="text-gray-500 text-sm mt-1 line-clamp-2">{faq.answer}</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <button onClick={() => setEditItem({ ...faq })} className="text-gray-400 hover:text-blue-600 transition p-1"><i className="ri-edit-line" /></button>
                  <button onClick={() => setDeleteId(faq.id)} className="text-gray-400 hover:text-red-500 transition p-1"><i className="ri-delete-bin-line" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {editItem && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl w-full max-w-lg my-8">
            <div className="flex items-center justify-between p-6 border-b">
              <h2 className="font-semibold text-gray-900">{editItem.id ? 'Uredi pitanje' : 'Novo pitanje'}</h2>
              <button onClick={() => setEditItem(null)} className="text-gray-400 hover:text-gray-600"><i className="ri-close-line text-xl" /></button>
            </div>
            <form onSubmit={handleSave} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Pitanje *</label>
                <input className="input" value={editItem.question} onChange={e => setEditItem({ ...editItem, question: e.target.value })} required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Odgovor *</label>
                <textarea className="input" rows={5} value={editItem.answer} onChange={e => setEditItem({ ...editItem, answer: e.target.value })} required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Redosled</label>
                <input type="number" className="input w-24" value={editItem.sort_order ?? 0} onChange={e => setEditItem({ ...editItem, sort_order: Number(e.target.value) })} />
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button type="button" onClick={() => setEditItem(null)} className="px-4 py-2 text-sm text-gray-600">Otkaži</button>
                <button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-medium px-6 py-2 rounded-lg transition">
                  {saving ? 'Čuvanje...' : 'Sačuvaj'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deleteId && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full">
            <h3 className="font-semibold text-gray-900 mb-2">Obriši pitanje?</h3>
            <p className="text-gray-500 text-sm mb-5">Ova akcija je trajna.</p>
            <div className="flex gap-3 justify-end">
              <button onClick={() => setDeleteId(null)} className="px-4 py-2 text-sm text-gray-600">Otkaži</button>
              <button onClick={handleDelete} className="bg-red-600 hover:bg-red-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition">Obriši</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
